__webpack_require__.p = "https://accept.bosspaints.be/_next/";